import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppWithProviders from './app';
const rootElement = document.getElementById('app');
if (rootElement === null) {
    throw new Error('Root element not found');
}
const root = createRoot(rootElement);
root.render(_jsxs(StrictMode, { children: [_jsx("h1", { children: "Microfronted: rs-hunter-tools" }), _jsx(AppWithProviders, { country: "CO" })] }));
